module.exports = __webpack_public_path__ + "assets/img/3_1181.f2805349.jpg";